module.exports = __webpack_public_path__ + "img/0Q3A4612_FoamcoreMatted.7ee06042.jpg";